import React, {useState, useEffect} from 'react';
import {toJS} from 'mobx';
import {Table, Radio, Button, Popconfirm, Select, message} from 'antd';
import NumberInput from "../../../components/NumberInput";
import FormRow from "./FormRow";
import history from "../../../libs/history";
import styles from './layout.module.less'

import store from "../store";
import projectStore from "../../user/project/store";
import {observer} from 'mobx-react';
// import lodash from "lodash";
// import moment from "moment"


// the hook
import {useTranslation} from 'react-i18next';

import deletePng from './delete.png'

export default observer(function () {
  const {t, i18n} = useTranslation();
  const {records, selectedRowKeys, isFetching} = store
  const [loading, setLoading] = useState(false)

  const columns = [
    {
      title: t('全选'),
      dataIndex: 'catalog',
      className: 'pl0',
      width: 50,
      align:'center',
      fixed: true,
      render: (val,info) => <div
        className={[styles.badge, val !== 'Sale' ? styles.badgeGhost : '', i18n.language === 'en' ? styles.autoWidth : ''].join(' ')}>
         {t(info?.catalogName?.charAt(0)==='销'?'购':info?.catalogName?.charAt(0))}
      </div>,
    },
    {
      title: t('产品品名'),
      dataIndex: 'name',
      align: 'center',
      fixed: true,
      width: 160,
    },
    {
      title: t('品牌'),
      dataIndex: 'brand',
      align: 'center',
      fixed: true,
      width: 130,
    },
    {
      title: t('规格'),
      dataIndex: 'formats',
      align: 'center',
      fixed: true,
      width: 130,
    },
    {
      title: t('货号'),
      dataIndex: 'factoryCode',
      align: 'center',
      fixed: true,
      width: 150,
    },
    {
      title: t('产品说明'),
      dataIndex: 'desc',
      align: 'center',
      fixed: true,
      width: 170,
      render: val => <div>{val ? val : '一'}</div>,
    },
    {
      title: t('数量'),
      dataIndex: 'number',
      align: 'center',
      fixed: true,
      width: 90,
      render: (text, record, index) => <div style={{margin: '0 0.104rem'}}>
        <NumberInput size='small' min={1}
                     defaultValue={text}
                     onChange={(val) => store.updateRecord(index, record, val).then()}/></div>,
    },
    // {
    //   title: t('项目编号'),
    //   dataIndex: 'extra_sn',
    //   align: 'center',
    //   fixed: true,
    //   width: 138,
    //   render: (text, record, index) => <div>
    //     <Select defaultValue={text}
    //             allowClear={true}
    //             onChange={(val) => store.updateRecord(index, record, val, 'extra_sn').then()}
    //             placeholder={t('项目编号')}
    //             style={{width: '0.71875rem', textAlign: "center"}}>
    //       {
    //         projectStore.records.map((item) => (
    //           <Select.Option key={item.id} value={item.sn}>
    //             <span title={item.name + '[' + item.sn + ']'}>{item.name}[{item.sn}]</span>
    //           </Select.Option>
    //         ))
    //       }
    //     </Select>
    //   </div>,
    // },
    /*    {
          title: '期望交货日期',
          dataIndex: 'delivery_date',
          align: 'center',
          fixed: true,
          width: 130,
          render: val => <DatePicker className={styles.date} onChange={onDateChange} disabledDate={disabledDate}
                                     placeholder='请选择日期' style={{width: 130}}/>,
        },*/
    // {
    //   title: t('需要计量'),
    //   dataIndex: 'is_measure',
    //   align: 'center',
    //   fixed: true,
    //   width: 90,
    //   render: (val, record, index) =>
    //     <Radio checked={val} onClick={() => {
    //       onRadioClick(val, record, index)
    //     }} value={true}/>
    // },
    {
      title: '',
      dataIndex: 'id',
      align: 'center',
      fixed: true,
      width: 100,
      render: (text, record, index) => <div className={styles.rowBtn}>
        <Popconfirm
          title={t("确定删除吗?")}
          onConfirm={() => {
            store.delRecord(text, index)
          }}
          okText={t("确定")}
          cancelText={t("取消")}>
            <img src={deletePng} alt="" style={{"cursor": "pointer",'width':'0.08333rem'}} />
          {/* <span className={['icon icon-del', styles.del].join(" ")}/> */}
        </Popconfirm>
      </div>,
    },
  ]

  useEffect(() => {

    projectStore.records.length === 0 ?
      projectStore.fetchRecords().then(() => store.fetchRecords())
      : store.fetchRecords()
  }, [])

  // const disabledDate = (current) => {
  //   return current < moment().subtract(1, 'days')
  // }

  const onRadioClick = (val, record, index) => {
    let newVal = !record['is_measure']
    store.updateRecord(index, record, newVal, 'is_measure').then(() => {
      records[index]['is_measure'] = newVal
    })
  }

  const onSelectChange = selectedRowKeys => {
    store.selectedRowKeys = selectedRowKeys
  }

  const clearCart = () => {
    // store.records = []
    // store.userAddRecords = []
    store.delRecordAll()
  }

  const postInquiry = () => {
    if (store.selectedRowKeys.length + store.selectedCustomKeys.length === 0) {
      message.warn('请选择商品')
      return
    }

    setLoading(true)
    store.postInquiry().then(() => {
      history.push('/cart/submit?id=' + store.orderId)
    }).finally(() => setLoading(false))

  }


  return (
    <React.Fragment>
      <div className={styles.cart}>
        <div className={['steps', styles.steps].join(" ")} data-class={'prev, cur'}>
          <div className="step cur">{t('我的购物车 ')}</div>
          <div className="step ">{t('提交求购单')}</div>
        </div>

        <div className={styles.listTitle}>
          <span className={styles.title}>{t('求购清单')}</span>
          <span className={styles.des}>{t('订购后在货期内发货，若因特殊原因货期状态发生变化，客服人员会第一时间与您确认货期。')}</span>
        </div>

        <Table className={styles.table}
               pagination={false}
               bordered
               rowSelection={{
                 selectedRowKeys,
                 onChange: onSelectChange,
               }}
               dataSource={toJS(store.records)}
               rowKey={record => record.id}
               loading={isFetching}
               columns={columns}/>

        <div className={styles.innerTitle}>{t('如您需要的商品不在商城中，可填写以下信息：请尽可能填写详细，以便我们更好的为您提供服务。')}</div>

        <FormRow/>

        <div className={styles.tableFooter}>
          <div className={styles.btns}>
            <Popconfirm
              title={t('确定清空购物车吗?')}
              onConfirm={clearCart}
              okText={t('确定')}
              cancelText={t('取消')}>
              <Button type='primary' ghost style={{marginRight: '0.104rem'}}>{t('清空求购单')}</Button>
            </Popconfirm>
            <Button  type='primary' loading={loading} onClick={postInquiry}>{t('提交求购单')}</Button>
            <p>{t('提交求购单后，我们会在2个小时内联系您')}</p>
          </div>
        </div>


      </div>

    </React.Fragment>
  )
})


